import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sendAgain", "messageField"];

  connect() {
    this.displaySendAgain();
    this.removeUnread();
    this.focusInputIfCurrentRequest();
  }

  displaySendAgain() {
    const expires = Date.parse(this.data.get("expires"));

    if (expires > new Date()) {
      this.sendAgainTarget.classList.remove("no-show");
    }
  }

  hideButton() {
    const message = this.data.get("disabled");
    this.sendAgainTarget.disabled = true;
    this.sendAgainTarget.value = message;
  }

  removeUnread() {
    const unRead = this.element.querySelector(".item.unread");
    if (unRead) {
      unRead.classList.remove("unread");
    }
  }

  focusInputIfCurrentRequest() {
    if (
      this.hasMessageFieldTarget &&
      this.firstRequest != undefined &&
      this.firstRequest.id == this.element.id
    ) {
      this.messageFieldTarget.focus();
    }
  }

  get firstRequest() {
    return this.element.parentElement.querySelector(".location-request");
  }
}
